const users = {
    assigner: {
        header: 'Przypisywanie grup',
        buttons: {
            cancel: {
                label: 'Anuluj'
            },
            confirm: {
                label: 'Przypisz',
            },
        },
        toAssign: {
            header:{
                title: 'Grupy do wybrania',
                text: 'Kliknij aby przenieść grupę na drugą liste',
            },
            searchPlaceholder: 'Wyszukaj...',
            tooltip: 'Kliknij aby przenieść grupę na drugą liste',
        },
        assigned: {
            header: {
                title: 'Grupy do przypisania',
                text: 'Kliknij aby przenieść grupę na pierwszą liste',
            },
            searchPlaceholder: 'Wyszukaj...',
            tooltip: 'Kliknij aby przenieść grupę na pierwszą liste',
        },
    }
};

export default users;